import { Box, Avatar, List, ListItem, ListItemAvatar, ListItemText, Typography, Tooltip } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { DeleteIcon, EditIcon } from '../../../config/svg/CommonSvgIcon';
import { OKRButton } from '../../Common/OKRButton';
import { useTranslation } from 'react-i18next';
import { getRandomBackgroundColor, getRandomColor, getTime, getUserDetails, getUserName } from '../../../config/utils';
import {
	deleteCommentsPost,
	getCommentsList,
	getConversationReplyList,
	getLikesList,
	likeRecognization,
} from '../../../action/recognize';
import { PopperMenu } from '../../Admin/CommonComponent/PopperMenu';
import { useSnackbar } from 'notistack';
import { CreateReply } from './CreateReply';
import AlertDialog from '../../Common/Dialog';
import { getLocalStorageItem, removeLocalStorageItem } from '../../../services/StorageService';
import { AnimatedIcon } from '../../Common/AnimatedIcon';
import LikeImg from '../../../images/Like.svg';
import { ReadMore } from '../ReadMore';
import { KebabIcon } from '../../../config/svg/CommonSvg';
import { EnumCommentModuleId, EnumLikeModule, Enums } from '../../../config/enums';
import { ReplyArrow } from '../../../config/svg/ArrowSvg';
import { getGoalDataApi, getRepliesData, saveLikeGoalData } from '../../../action/perform';

export const ReplyList = (props: any) => {
	const {
		commentDetailsId,
		commentData,
		updateCount,
		showReplyBox,
		setShowReplyBox,
		setReplyHighlight,
		replyHighlight,
		getSourceId,
		setIsTaskEdited,
		isTaskEdited,
		scrollTo,
		replyUser,
		setReplyUser,
		setPrefilledUser,
		setModalProps,
		setHideBox,
		hideBox,
		isViewOnly,
		isTeamReviewConversation,
		kr,
	} = props;
	const [anchorEl, setAnchorEl] = useState(null);
	const [popperMenuClicked, setPopperMenuClicked] = useState<boolean>(false);
	const { t } = useTranslation();
	const [open, setOpen] = useState<boolean>(false);
	const [openLike, setOpenLike] = useState<boolean>(false);
	const [apiLoading, setApiLoading] = useState<boolean>(false);
	const [editedConversation, setEditedConversation] = useState<any>({});
	const [conversationAction, setconversationAction] = useState<any>('');
	const [openDeleteDialog, setOpenDeleteDialog] = React.useState<boolean>(false);

	const [postText, setPostText] = React.useState<any>('');
	const dispatch = useDispatch();
	const { enqueueSnackbar } = useSnackbar();
	const [replyListData, setReplyListData] = useState<any[]>([]);
	const [likedId, setLikedId] = useState<number>(0);

	const [pagingInfo, setPagingInfo] = useState<any>({
		pageIndex: 1,
		pageSize: 5,
		totalPages: 1,
		totalRecords: 0,
	});
	const loggedInUserDetail = getUserDetails();
	const [likeAnimation, setLikeAnimation] = useState<number>(0);
	const [editCommentId, setEditEditId] = useState<number>(0);
	const [likeData, setLikeData] = useState<any[]>([]);
	const [savedId, setSavedId] = useState(0);
	const [clickedData, setClickedData] = useState<any>({});

	let userDetail = getUserDetails();

	useEffect(() => {
		if (replyHighlight) {
			getReplies(1, 99999);
			setReplyHighlight(false);
		} else {
			getReplies();
		}
	}, []);

	React.useEffect(() => {
		if (hideBox) {
			setHideBox(false);
			setShowReplyBox(false);
			setEditedConversation({});
			setClickedData({});
		}
	}, [hideBox]);
	const getReplies = async (pageIndex = 1, pageSize = 5, scrollToEnd = false, isCounterAdd = true) => {
		setEditEditId(0);
		setApiLoading(true);
		let data = `moduleId=${
			isTeamReviewConversation
				? EnumCommentModuleId.PerformanceTeamReviewReplyComments
				: EnumCommentModuleId.PerformanceGoalReviewReplyComments
		}&moduleDetailsId=${commentDetailsId}&pageSize=10&pageIndex=1`;
		const response: any = await dispatch(getRepliesData(data));
		if (Boolean(response) && response.data.status === 200) {
			setPagingInfo(response.data.pagingInfo ? response.data.pagingInfo : pagingInfo);
			if (response.data.pagingInfo?.pageIndex === 1) {
				setReplyListData(response.data.entity.commentDetailResponses);
				updateCount(props.commentDetailsId, isCounterAdd, 'comment', response.data.pagingInfo?.totalRecords);
			} else {
				if (response.data.entity.commentDetailResponses && response.data.pagingInfo?.pageIndex > 1) {
					setReplyListData([...replyListData, ...response.data.entity.commentDetailResponses]);
				} else if (
					response.data.entity.commentDetailResponses === null ||
					response.data.entity.commentDetailResponses.length === 0
				) {
					setReplyListData([]);
				}

				if (!response.data.pagingInfo?.pageIndex) {
					updateCount(props.commentDetailsId, isCounterAdd, 'comment', 0);
				}
			}

			let conversationHighlight: any = getLocalStorageItem('conversationHighlight');
			if (Boolean(conversationHighlight)) {
				conversationHighlight = JSON.parse(conversationHighlight);
				if (conversationHighlight.conversationsReplyId > 0) {
					setSavedId(conversationHighlight.conversationsReplyId);
					const selectedEl = document.getElementById(`${'commentPost-' + conversationHighlight.conversationsReplyId}`);
					if (selectedEl) {
						selectedEl.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
					}
				}
			}
			setApiLoading(false);

			if (scrollToEnd) {
				let responseIndex = response.data.entity.commentDetailResponses.length - 1;
				if (
					responseIndex >= 0 &&
					response.data.entity.commentDetailResponses &&
					response.data.entity.commentDetailResponses[responseIndex]
				) {
					setTimeout(() => {
						const selectedEl = document.getElementById(
							`${'commentPost-' + response.data.entity.commentDetailResponses[responseIndex].commentDetailsId}`
						);
						if (selectedEl) {
							selectedEl.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
						}
					}, 500);
				}
			} else if (showReplyBox) {
				scrollTo('create-reply-box');
			}

			setTimeout(() => {
				setSavedId(0);
				removeLocalStorageItem('conversationHighlight');
			}, 7000);
		} else {
			setApiLoading(false);
			enqueueSnackbar(t('someErrorOccurred'), {
				variant: 'error',
				autoHideDuration: 5000,
			});
		}
	};
	const handleDialogCancelClick = (e: any, type: any) => {
		if (type === 1) {
			handleConfirmClick();
		}
		setOpenDeleteDialog(!openDeleteDialog);
		setEditedConversation({});
		setconversationAction('');
	};
	const handleConfirmClick = async () => {
		let data = `commentDetailsId=${editedConversation.commentDetailsId}`;
		const deleteTaskResponse: any = await dispatch(deleteCommentsPost(data));

		if (Boolean(deleteTaskResponse) && deleteTaskResponse.data.status === 200) {
			enqueueSnackbar(deleteTaskResponse?.data?.messageList?.messageSuccess, {
				variant: 'success',
				autoHideDuration: 5000,
			});
			getReplies(1, pagingInfo.pageIndex * 5, false, false);
		} else {
			enqueueSnackbar(t('someErrorOccurred'), {
				variant: 'error',
				autoHideDuration: 5000,
			});
		}
	};

	const likeReplyList = async (conversation: any, like: any) => {
		setLikeAnimation(conversation.commentDetailsId);
		let payload = {
			commentDetailsId: conversation.commentDetailsId,
			employeeId: loggedInUserDetail.employeeId,
			isActive: like,
			moduleDetailsId: conversation.commentDetailsId,
			moduleId: isTeamReviewConversation
				? EnumLikeModule.CommentReplyTeamReviewLike
				: EnumLikeModule.CommentReplyReviewGoalLike,
		};
		let response: any = await dispatch(saveLikeGoalData(payload));
		if (response.data.status === Enums.STATUS_SUCCESS) {
			let counter = like ? 1 : -1;
			let replyListDataCopy = replyListData.map((listData: any) => listData);
			const index = replyListDataCopy.findIndex(
				(listData: any) => conversation.commentDetailsId === listData.commentDetailsId
			);
			if (index > -1) {
				replyListDataCopy[index].isLiked = like;
				replyListDataCopy[index].totalLikes += counter;
				if (like) {
					replyListDataCopy[index].conversationReactions.push({
						fullName: loggedInUserDetail.firstName + ' ' + loggedInUserDetail.lastName,
						employeeId: loggedInUserDetail.employeeId,
						imagePath: loggedInUserDetail.imagePath,
						emailId: loggedInUserDetail.emailId,
					});
				} else {
					var indexC = replyListDataCopy[index].conversationReactions.findIndex(
						(x: any) => x.employeeId === loggedInUserDetail.employeeId
					);
					if (indexC !== -1) {
						replyListDataCopy[index].conversationReactions.splice(indexC, 1);
					}
				}
			}
			setReplyListData(replyListDataCopy);
		} else {
			enqueueSnackbar(response?.data?.messageList.message, {
				variant: 'error',
				autoHideDuration: 5000,
			});
		}
	};

	const handleOpen = async (event: any, item: any) => {
		setAnchorEl(event.currentTarget);
		setOpenLike(true);
		setLikedId(item.commentDetailsId);
	};
	const handleClose = () => {
		setOpenLike(false);
		setAnchorEl(null);
		setLikeData([]);
		setLikedId(0);
	};

	const handleClick = (event: any, data: any) => {
		if (isTaskEdited) {
			setModalProps({ open: true, event: event });
		} else {
			setModalProps({ open: false, event: {} });
			setAnchorEl(anchorEl ? null : event.currentTarget);
			setOpen(true);
			setClickedData(data);
		}
		setLikeAnimation(0);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
		setOpen(false);
		setClickedData({});
	};

	const editConversation = (conversation: any) => {
		handleMenuClose();
		setTimeout(function () {
			setEditedConversation(conversation);
		}, 200);
	};

	const handleDeleteConversation = (conversation: any) => {
		setEditedConversation(conversation);
		setOpenDeleteDialog(!openDeleteDialog);
		handleMenuClose();
		setconversationAction('delete');
	};

	return (
		<>
			{replyListData.length > 0 &&
				replyListData.map((item: any) => {
					return (
						<>
							<Box
								className={`cfr-reply-list-info ${item.isCommentHighlight ? 'highlight' : ''}`}
								id={`${'commentPost-' + item.commentDetailsId}`}
							>
								<Box className='cfr-reply-list-content'>
									{item.imagePath ? (
										<Avatar className={'user-avtar'} src={item.imagePath} />
									) : (
										<Avatar
											className={'user-avtar'}
											style={{
												backgroundColor: getRandomBackgroundColor(item.backGroundColorCode),
												color: getRandomColor(item.colorCode),
											}}
										>
											{getUserName(item)}
										</Avatar>
									)}
									<Box className='comment-section'>
										<Box className='cfr-list-inner'>
											<Box className='cfr-list-content'>
												<Typography className='author-name'>{item.fullName}</Typography>
												<Box className='timestamp'>
													<Typography variant='body2'>{getTime(item.createdOn)}</Typography>{' '}
													{item.isEdited ? <Typography variant='body2'>{t('editedLabel')}</Typography> : <></>}
												</Box>
												<Box className='collapse-content'>
													{editedConversation?.commentDetailsId &&
													item.commentDetailsId === editedConversation.commentDetailsId &&
													conversationAction !== 'delete' ? (
														<>
															{' '}
															<CreateReply
																{...props}
																getReplies={getReplies}
																commentData={commentData}
																commentDetailsId={props.commentDetailsId}
																replyUser={replyUser}
																updateCount={updateCount}
																replyPageIndex={pagingInfo.pageIndex}
																getSourceId={getSourceId}
																replyData={editedConversation}
																setEditedConversation={setEditedConversation}
																setShowReplyBox={setShowReplyBox}
																setIsTaskEdited={setIsTaskEdited}
																performanceGoalsList={props.performanceGoalsList}
																kr={kr}
																isTeamReviewConversation={isTeamReviewConversation}
															/>{' '}
														</>
													) : (
														<ReadMore {...props} text={item.comments} isHtmlContent={true} />
													)}
												</Box>
											</Box>
											{loggedInUserDetail.employeeId === item.employeeId &&
												(item.moduleId === EnumCommentModuleId.PerformanceGoalReviewReplyComments ||
													item.moduleId === EnumCommentModuleId.PerformanceTeamReviewReplyComments) && (
													<OKRButton
														title={t('moreOptions')}
														className={`menu-btn ${
															open && clickedData.commentDetailsId === item.commentDetailsId ? 'active' : ''
														}`}
														handleClick={(e: any) => {
															handleClick(e, item);
														}}
														icon={<KebabIcon />}
													/>
												)}
										</Box>
										<Box className='cfr-reply-action'>
											<Box className='cfr-reply-btm-left'>
												{!item.isLiked ? (
													<OKRButton
														className='like-btn'
														handleClick={() => {
															likeReplyList(item, true);
														}}
														text={t('likeLevel')}
													/>
												) : (
													<Box className='like-filled-btn'>
														<OKRButton
															className={`like-btn ${likeAnimation === item.commentDetailsId ? 'btn-anim' : ''}`}
															icon={
																<>
																	{likeAnimation === item.commentDetailsId && (
																		<AnimatedIcon
																			className='like-animation-img'
																			width='60'
																			type='image/svg+xml'
																			alt='No user'
																			imagePath={LikeImg}
																		/>
																	)}
																</>
															}
															text={<span className='remove-img'>{t('likedLevel1')}</span>}
															handleClick={() => {
																likeReplyList(item, false);
																setLikeAnimation(0);
															}}
															disabled={
																item.moduleId !== EnumCommentModuleId.PerformanceGoalReviewReplyComments &&
																item.moduleId !== EnumCommentModuleId.PerformanceTeamReviewReplyComments
															}
														/>
													</Box>
												)}

												<OKRButton
													className='reply-btn'
													text={t('reply')}
													handleClick={() => {
														if (
															item.moduleId === EnumCommentModuleId.PerformanceGoalReviewReplyComments ||
															item.moduleId === EnumCommentModuleId.PerformanceTeamReviewReplyComments
														) {
															setShowReplyBox(true);
														}
														setPrefilledUser(item);
														scrollTo('create-reply-box');
													}}
												/>
											</Box>
											<Box className='cfr-reply-btm-right'>
												<List disablePadding>
													{
														<ListItem
															aria-owns={open ? 'mouse-over-popover' : undefined}
															aria-haspopup='true'
															onMouseEnter={(e: any) => {
																item.totalLikes > 0 && handleOpen(e, item);
															}}
															onMouseLeave={handleClose}
															className={item.totalLikes > 0 ? 'active' : ''}
														>
															<ListItemText
																className={item.totalLikes > 0 ? 'like-popup' : ''}
																primary={`${item.totalLikes} ${item.totalLikes > 1 ? t('likedLevel') : t('likeLevel')}`}
															/>

															{openLike && item.commentDetailsId === likedId && (
																<Box>
																	<PopperMenu
																		{...props}
																		children={
																			<>
																				{item?.conversationReactions?.length > 0 &&
																					item.conversationReactions.map((likeList: any) => {
																						return (
																							<ListItem>
																								<Box className='user-info'>
																									<Box className='user-img'>
																										{likeList?.imagePath ? (
																											<Avatar src={likeList?.imagePath} />
																										) : (
																											<Avatar>
																												{getUserName({
																													fullName: '',
																													firstName: likeList?.firstName,
																													lastName: likeList?.lastName,
																												})}
																											</Avatar>
																										)}
																									</Box>
																									<Box className='user-info-details'>
																										{likeList?.fullName?.length > 30 ? (
																											<Tooltip title={likeList.fullName} arrow>
																												<Typography variant='subtitle2'>
																													{likeList?.fullName.substring(0, 30)}
																													...
																												</Typography>
																											</Tooltip>
																										) : (
																											<Typography>{likeList.fullName}</Typography>
																										)}

																										{likeList?.emailId?.length > 28 ? (
																											<Tooltip title={likeList.emailId} arrow>
																												<Typography variant='subtitle2'>
																													{likeList?.emailId.substring(0, 28)}
																													...
																												</Typography>
																											</Tooltip>
																										) : (
																											<Typography variant='subtitle2'>{likeList?.emailId}</Typography>
																										)}
																									</Box>
																								</Box>
																							</ListItem>
																						);
																					})}
																			</>
																		}
																		popperClassName={'conversation-drawer-like recog-liked-by-dropdown'}
																		anchorEl={anchorEl}
																		handleClose={handleClose}
																		popperPlacement={'bottom'}
																		open={openLike}
																	/>
																</Box>
															)}
														</ListItem>
													}
												</List>
											</Box>
										</Box>
									</Box>
								</Box>
							</Box>
						</>
					);
				})}

			<PopperMenu
				anchorEl={anchorEl}
				open={open}
				handleClose={handleClose}
				popperClassName={'popper-menu popper-menu-type2 popper-cfr-menu'}
				{...props}
				children={
					<>
						<ListItem
							onClick={() => {
								editConversation(clickedData);
							}}
						>
							<ListItemAvatar>
								<EditIcon />
							</ListItemAvatar>

							<ListItemText primary={t('editLabel')} />
						</ListItem>
						<ListItem
							onClick={() => {
								handleDeleteConversation(clickedData);
							}}
						>
							<ListItemAvatar>
								<DeleteIcon />
							</ListItemAvatar>
							<ListItemText primary={t('delete')} />
						</ListItem>
					</>
				}
			></PopperMenu>
			{!isViewOnly && showReplyBox && !editedConversation?.commentDetailsId && !apiLoading && (
				<>
					<Box className='cfr-reply-list-info'>
						<Box className='cfr-reply-list-content'>
							{loggedInUserDetail && loggedInUserDetail.imagePath ? (
								<Avatar
									className='avatar-default'
									alt={`${loggedInUserDetail.firstName} ${loggedInUserDetail.lastName}`}
									src={loggedInUserDetail.imagePath}
								/>
							) : (
								<Avatar className='avatar-default'>
									{getUserName({
										firstName: loggedInUserDetail.firstName,
										lastName: loggedInUserDetail.lastName,
										fullName: loggedInUserDetail.fullname,
									})}
								</Avatar>
							)}

							<Box className='comment-section'>
								<CreateReply
									{...props}
									getReplies={getReplies}
									commentData={commentData}
									commentDetailsId={props.commentDetailsId}
									replyUser={replyUser}
									updateCount={updateCount}
									replyPageIndex={pagingInfo.pageIndex}
									getSourceId={getSourceId}
									setEditedConversation={setEditedConversation}
									setShowReplyBox={setShowReplyBox}
									setIsTaskEdited={setIsTaskEdited}
									performanceGoalsList={props.performanceGoalsList}
								/>
							</Box>
						</Box>
					</Box>
				</>
			)}

			<Box className='load-more-area'>
				{pagingInfo?.totalPages > 1 && pagingInfo?.totalPages !== pagingInfo.pageIndex && (
					<Box className='load-more'>
						<OKRButton
							handleClick={(e) => {
								getReplies(pagingInfo.pageIndex + 1 || 1, 5);
							}}
							className={`load-more-btn btn-small-text`}
							text={t('viewMoreReply')}
						/>
					</Box>
				)}
				<Box className='view-less'>
					<OKRButton
						handleClick={() => {
							props.setReplyCommentId(0);
							scrollTo(`${'recogConversationPost-' + props.commentDetailsId}`);
						}}
						className={`load-more-btn btn-small-text`}
						text={t('hideReply')}
					/>
				</Box>
			</Box>

			{openDeleteDialog && (
				<AlertDialog
					module='information'
					message={t('deleteConversationReply')}
					handleCloseModal={handleDialogCancelClick}
					modalOpen={openDeleteDialog}
				/>
			)}
		</>
	);
};
